<template>
    <div class="vote">
        <div class="dialog-ibox-content">
            <el-form :model="voteruleForm"  ref="voteruleForm" label-width="150px"
                class="demo-ruleForm forms-lines">
                <el-form-item label="投票名称：">
                    <span>{{voteruleForm.vote_name}}</span>
                </el-form-item>
                <el-form-item label="截止时间：" style="margin-top:10px">
                    <span>{{voteruleForm.deadline}}</span>
                </el-form-item>
                <div class="problem_box" v-for="(p,index) in voteruleForm.problems" :key="index">
                    <el-form-item label="标题：" style="margin-top:10px">
                        <span>{{p.problem}}</span>
                    </el-form-item>
                    <el-form-item :label="o.option" v-for="(o,ind) in p.options" :key="ind" style="margin-top:15px">
                        <div style="margin-top:10px">
                            <el-progress :percentage="o.choice_lv" :color="(o.selected==1)?'#e6a23c':'#909399'" ></el-progress>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                vote: [],
                vote_id: '',
                loading: false,
                height: null,
                voteruleForm: {},

            }
        },
        mounted() {
            this.getHeight()

        },
        methods: {
            getHeight() {
                let that = this

                that.height = window.innerHeight - 175 + 'px'
                window.onresize = () => {

                    that.height = window.innerHeight - 175 + 'px'
                }
            },
            getuservoterecord(id) {
                axios
                    .post("/admin/VoteHistoryRecord/getVotePeopleRecord", {
                        vote_id: sessionStorage.getItem('vote_id'),
                        people_id: id
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.voteruleForm = response.data.data
                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
           

        }
    }
</script>

<style lang="scss" scoped>

</style>